<div class="modal-header impact-outcome-header">
  <div class="modal-title f-20">Impact Rating</div>
  <div class="modal-btn-right">
    <div class="btn-group mr-4">
      <button class="btn btn-blue text-white btn-sm mr-2" (click)="saveImpactAssessmentList()">Save</button>
      <button class="btn btn-blue text-white btn-sm" (click)="resetImpactAssesmnent()">Reset</button>
    </div>
    <button class="fa fa-times" [mat-dialog-close]="" style="float: right;cursor: pointer;background: none;border:none"
      aria-hidden="true"></button>
  </div>
</div>
<div class="modal-body" style="height: 750px;overflow: auto;">
  <app-impact-outcome [impactAssessment]="ratingInfo.impactAssessment" [searchedJuris]="ratingInfo.jurisdictionList" [userAccessToken]="ratingInfo.userAccessToken">
  </app-impact-outcome>
</div>